import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet
} from '@angular/router';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppService } from './core/data-access/app.service';

@Component({
    selector: 'app-root',
    imports: [CommonModule, RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  private router = inject(Router);
  private appService = inject(AppService);
  private route = inject(ActivatedRoute);

  constructor() {
    // Listen for router events
    this.router.events.pipe(takeUntilDestroyed()).subscribe(e => this.onNavigationChanged(e));
  }

  ngOnInit() {
    this.appService.applyTheme();
  }

  /**
   * Handle global events when the router changes views
   *
   * @param {Event} event Navigation event data
   */
  private onNavigationChanged(event: Event) {
    if (event instanceof NavigationStart) {
      // this.appService.showLoading();
    } else if (
      event instanceof NavigationEnd ||
      event instanceof NavigationCancel ||
      event instanceof NavigationError
    ) {
      // this.appService.hideLoading();
    }
  }
}
